import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const DELETE_DROP_ANTENNA = gql`
  mutation deleteDropAntenna($input: DeleteNodeInput!) {
    deleteDropAntenna(input: $input)
  }
`;

export const deleteDropAntenna = (propertyId: number) => (nodeId: string) => {
  return requestGQL(DELETE_DROP_ANTENNA, { input: { propertyId, nodeId } });
};
